import { z } from 'zod';

export const VisitFormInputSchema = z.object({
  patient: z.object({
    firstName: z.string().min(1, 'Patient name is required'),
    patientAge: z.number().optional().or(z.string().optional()),
    gender: z.string().nullable().optional(),
    chiefComplaint: z.string().nullable().optional(),
  }),
  date: z.string().min(1, 'Visit date is required'),
  startTime: z.string().min(1, 'Visit time is required'),
  roomNumber: z.string().nullable().optional(),
});
